import { RoleInfoComponentTabs } from "@/Administration/Models/UI/Roles/RoleInfoComponentTabs";

import styles from "./RoleManagementComponent.module.scss";

interface IRoleInfoTabMenuComponentsProps {
    onChange(clickedTab: RoleInfoComponentTabs): void;
    currentTab: RoleInfoComponentTabs;
}

function RoleInfoTabMenuComponent(props: Readonly<IRoleInfoTabMenuComponentsProps>): JSX.Element {
    return (
        <div className={`${styles.tabMenu} userinfo-menu`}>
            <button
                className={"userinfo-menu-item" + ((props.currentTab == RoleInfoComponentTabs.GeneralInformation) ? " selected" : "")}
                onClick={() => props.onChange(RoleInfoComponentTabs.GeneralInformation)}
                data-cy="rolesDetails-generalInfoTab"
            >
                {/* // the used vocab resource differs from the MOCK */}
                {cacheStore.GetString("InformationLabel")}
            </button>
            <button
                className={"userinfo-menu-item" + ((props.currentTab == RoleInfoComponentTabs.Permissions) ? " selected" : "")}
                onClick={() => props.onChange(RoleInfoComponentTabs.Permissions)}
                data-cy="roleDetails-permssionsTab"
            >
                {cacheStore.GetString("PermissionsLabel")}
            </button>
        </div>
    );
}

export { RoleInfoTabMenuComponent };
